/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import FormContainer from '../../../../FormContainer/FormContainer';
import { editAffiliate } from '../form/defaultState/state';
import { handleFormObjectChange } from '../../../../Utilities/HandleFormObjectChange';
import { validateForSubmit } from '../../../../Utilities/ValidationHelper/ValidateForm';
import { NetworkRequest } from '../../../../Utilities/NetworkRequests/NetworkRequests';

export default class EditAffiliate extends Component {
  state = {
    formValues: editAffiliate(),
    submitting: false,
    dialog: {
      message: '',
      type: 'error',
      title: 'Error'
    }
  };

  componentDidMount() {
    this.loadFormValues();
  }

  loadFormValues = () => {
    const { formValues } = this.state;

    [
      'affiliate_name',
      'is_external',
      'show_spanish',
      'traffic_source',
      'logpixel',
      'giraffeAffiliate',
      'reconcileGoogleAffiliate',
      'reconcileFacebookAffiliate',
      'ottoNativeAffiliate',
      'outbound_calls'
    ].map((column) =>
      Object.assign(formValues, formValues, {
        [column]: {
          ...formValues[column],
          value: this.props.row[column] || formValues[column].value,
          options: this.props.options[column] || formValues[column].options
        }
      })
    );

    this.setState({ formValues });
  };

  handleChange = (field, value) => {
    const formValues = handleFormObjectChange(field, value, {
      ...this.state.formValues
    });
    this.setState({ formValues });
  };

  toggleDialog = (message = '', type = 'error', title = 'Error') => {
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });
    if (message === '' && type === 'success') {
      this.props.toggleDrawer();
    }
  };

  handleSubmit = () => {
    const { valid, messages } = validateForSubmit(this.state.formValues);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return false;
    }
    this.handleSubmitRequest();
  };

  handleSubmitRequest = () => {
    Object.keys(this.state.formValues).map((key) =>
      this.props.onChange(this.props.row, key, this.state.formValues[key].value)
    );
    this.setState({ submitting: true }, () =>
      NetworkRequest('affiliates', {
        action: 'updateAffiliate',
        affiliate_id: this.props.row.affiliate_id,
        affiliate_name: this.props.row.affiliate_name,
        is_external: this.props.row.is_external,
        traffic_source: this.props.row.traffic_source,
        show_spanish: this.props.row.show_spanish,
        logpixel: +this.props.row.logpixel,
        giraffeAffiliate: +this.state.formValues.giraffeAffiliate.value,
        isReconcileGoogle:
          +this.state.formValues.reconcileGoogleAffiliate.value,
        isReconcileFacebook:
          +this.state.formValues.reconcileFacebookAffiliate.value,
        isOttoNative: +this.state.formValues.ottoNativeAffiliate.value,
        isOutboundCalls: +this.state.formValues.outbound_calls.value
      })
        .then(({ data }) => this.handleResponse(data))
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleResponse = (data) => {
    this.setState({ submitting: false }, () =>
      this.toggleDialog(
        data.message,
        data.success ? 'success' : 'error',
        data.success ? 'Success' : 'Error'
      )
    );
  };

  render() {
    const { formValues, submitting, dialog } = this.state;
    return (
      <FormContainer
        formValues={formValues}
        submitting={submitting}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        inputWidth={8}
        separateBlock
        dialog={dialog}
        toggleDialog={this.toggleDialog}
      />
    );
  }
}
